import { newId } from "../ids.js";
import { isoString, systemClock, type Clock } from "../time.js";
import type { Task, TaskInput } from "./types.js";

/** Build a new Task record from user input. Pure: doesn't persist. */
export function createTask(input: TaskInput, now: Clock = systemClock): Task {
  const ts = isoString(now());
  return {
    id: newId(),
    title: input.title,
    notes: input.notes?.trim() ?? "",
    due_at: input.due_at ?? null,
    deadline_at: input.deadline_at ?? null,
    all_day: input.all_day ?? false,
    duration_minutes: input.duration_minutes ?? 0,
    priority: input.priority ?? "none",
    matrix_pos: input.matrix_pos ?? null,
    matrix_hidden: input.matrix_hidden ?? false,
    custom_color: input.custom_color ?? null,
    is_event: input.is_event ?? false,
    location: input.location?.trim() ?? "",
    label_ids: input.label_ids ?? [],
    reminder_offsets: input.reminder_offsets ?? [],
    tz: input.tz ?? null,
    topic_ids: input.topic_ids ?? [],
    calendar_id: input.calendar_id ?? null,
    external_id: input.external_id ?? null,
    ical_uid: input.ical_uid ?? null,
    etag: input.etag ?? null,
    rev: input.rev ?? 0,
    source: input.source ?? null,
    external_calendar_id: input.external_calendar_id ?? null,
    link_rev: input.link_rev ?? 0,
    status: "open",
    completed_at: input.completed_at ?? null,
    snoozed_until: input.snoozed_until ?? null,
    recurrence_id: input.recurrence_id ?? null,
    parent_id: null,
    subtask_parent_id: input.subtask_parent_id ?? null,
    subtask_order: input.subtask_order ?? 0,
    created_at: ts,
    updated_at: ts,
    deleted_at: null,
  };
}
